import React from 'react';
import _ from 'lodash';
import moment, { Moment } from 'moment';

import { BookingCard } from './booking-card';
import { IRosterBooking, IRosterCustomer } from '../../types';
import { Stack } from '@good/ui/core';

interface BookingCardListProps {
  customer: IRosterCustomer;
  bookings: IRosterBooking[];
  day: Moment;
}

export const BookingCardList = ({ customer, bookings, day }: BookingCardListProps) => {
  const customerBookings = _.chain(bookings)
    .filter(
      (booking) => booking.bookerUserId === customer.customerId && moment(booking.startDateTime).isSame(day, 'day'),
    )
    .orderBy(['startDateTime'], ['asc'])
    .value();

  return (
    <Stack gap='xs'>
      {customerBookings.map((booking, idx) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <BookingCard booking={booking} key={idx} />
      ))}
    </Stack>
  );
};
